import React, { useState, useEffect } from 'react'
import AdminLayout from '../../AdminLayout'
import ContentHeader from '../../layout/ContentHeader'
import FormLayout from '../../layout/FormLayout';
import { CATEGORT_SAVE, GET_CATEGORY } from '../../../../data/url';
import httpClient from '../../../../http/HttpRequest';
import { useNavigate, useParams } from 'react-router-dom';
import Alert from '../../../../feature/Alert';
import { useTranslation } from 'react-i18next';

export default function AddCategory() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [directSubmit, setDirectSubmit] = useState(1);
  const action = typeof id === 'undefined' ? 'ADD' : 'UPDATE';
  const [formData, setFormData] = useState({
    formTitle: 'Add Category',
    formFields: [
      { label: 'name', id: 'category_name', type: 'text', name: 'category_name', placeholder: 'enter_category', value: '', required: true, min_length: 3 },
      { label: 'desc', id: 'description', type: 'textarea', name: 'description', placeholder: 'enter_desc', value: '', required: true },
    ],
    formErrors: { category_name: '', description: '' },
  });

  useEffect(() => {
    if (action === 'UPDATE') {
      setFormData(prevFormData => {
        const newFormField = {
          label: 'status',
          id: 'status',
          type: 'radio',
          name: 'status',
          value: '',
          required: true,
          options: [
            { label: 'active', value: "1", class: "success" },
            { label: 'deactive', value: "2", class: "danger" },
          ]
        };
        const newFormErrors = {
          ...prevFormData.formErrors,
          status: '',
        };
        const updatedFormFields = [...prevFormData.formFields, newFormField];
        return {
          ...prevFormData,
          formFields: updatedFormFields,
          formErrors: newFormErrors,
        };
      });
      if (id) {
        getCategoryData();
      }
    }
  }, [action]);

  const getCategoryData = async () => {
    if (id) {
      const res = await httpClient.post(GET_CATEGORY, { category_id: id });
      if (res.requestStatus === 'OK') {
        const result = res.result;
        if (result.status === 1) {
          setFormData(prevFormData => {
            const updatedFormFields = prevFormData.formFields.map(field => {
              if (field.name in result.data) {
                field.value = result.data[field.name];
              }
              return field;
            });

            return {
              ...prevFormData,
              formFields: updatedFormFields,
            };
          });
        } else {
          Alert.error(res.message);
          navigate('/root/product/categoryList');
        }
      }
    }
  }

  function handleFieldChange(fieldName, value) {
    setDirectSubmit(0);
    setFormData((prevFormData) => {
      const updatedFormFields = prevFormData.formFields.map((field) =>
        field.name === fieldName ? { ...field, value: value } : field
      );
      return {
        ...prevFormData,
        formFields: updatedFormFields,
      };
    });
  }

  function handleFieldBlur(fieldName, value) {
    setDirectSubmit(0);
    validateField(fieldName, value);
  }

  function validateField(fieldName, value) {
    setFormData((prevFormData) => {
      const updatedErrors = { ...prevFormData.formErrors };

      if (fieldName === 'category_name') {
        updatedErrors.category_name = value.trim() === '' ? 'field_required' : '';
      }
      if (fieldName === 'description') {
        updatedErrors.description = value.trim() === '' ? 'field_required' : '';
      }
      if (fieldName === 'status') {
        updatedErrors.description = value.trim() === '' ? 'field_required' : '';
      }

      return {
        ...prevFormData,
        formErrors: updatedErrors,
      };
    });

    return formData.formErrors;

  }

  function handleSubmit(e) {
    e.preventDefault();
    let post = {};
    let hasErrors = false;
    const updatedFormFields = formData.formFields.map((field) => {
      const allError = validateField(field.name, field.value);
      const error = allError[field.name];
      if (error !== '') {
        hasErrors = true;
      } else {
        post[field.name] = field.value;
      }
      return field;
    });

    setFormData((prevFormData) => ({
      ...prevFormData,
      formFields: updatedFormFields,
    }));
    console.log(formData);
    if (!hasErrors && directSubmit === 0) {
      if (action === 'UPDATE') post['category_id'] = id;
      subtmitData(post);
    } else {
      if (action === 'UPDATE') {
        Alert.warning(t('you_did_not_change_anything'));
      } else {
        Alert.warning(t('mandetory_fields'));
      }
    }
  }

  const subtmitData = async (post) => {
    const res = await httpClient.post(CATEGORT_SAVE, post);
    if (res.requestStatus === "OK") {
      const result = res.result;
      if (result.status === 1) {
        Alert.success(result.message);
        navigate('/root/product/categoryList');
      } else {
        Alert.failure(result.message);
      }
    }
  }

  function handleReset() {
    const updatedFormFields = formData.formFields.map((field) => ({
      ...field,
      value: '',
    }));

    setFormData((prevFormData) => ({
      ...prevFormData,
      formFields: updatedFormFields,
      formErrors: {},
    }));
  }

  return (
    <AdminLayout>
      <div className="content-wrapper">
        <ContentHeader
          title={action === 'UPDATE' ? 'update_category' : 'add_category'}
          subTitle="category"
          subTitleLink="root/product/categoryList"
        />
        <div className='col-md-6 m-auto'>
          <FormLayout
            formTitle={formData.formTitle}
            formFields={formData.formFields}
            formErrors={formData.formErrors}
            onFieldChange={handleFieldChange}
            onFieldBlur={handleFieldBlur}
            onSubmit={handleSubmit}
            handleReset={handleReset}
          />
        </div>
      </div>
    </AdminLayout>
  )
}
